

export enum VerificationType {
    EMAIL               = "email",
    PHONE               = "phone",
    ACCOUNT_CLOSURE     = "account_closure",
}

export type VerificationCodeSendProps = {
    email?: string;
    phone?: string;
    type: string;
}